import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../../../components/Button'
function WebsiteAppointmentRequestViewModal(props) {
  const {
    appointmentRequest,
    open,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      input,
    }
  } = props;

  const [portalNotes, setPortalNotes] = useState('');

  useEffect(() => {
    if (appointmentRequest) {
      setPortalNotes(appointmentRequest.portalNotes)
    }
  }, [])

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Request Details</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <TextField
          disabled
          fullWidth
          variant="outlined"
          label="Patient"
          name="Patient"
          value={appointmentRequest.name}
          className={input}
        />

        <TextField
          disabled
          fullWidth
          variant="outlined"
          label="Seeking appointment with listed provider"
          name="Provider"
          value={appointmentRequest.providerName}
          className={input}
        />

        <TextField
          disabled
          fullWidth
          label="Phone Number"
          value={appointmentRequest.phone}
          variant="outlined"
          className={input}
        />
        <TextField
          disabled
          fullWidth
          label="Birthdate"
          value={appointmentRequest.birthdate}
          variant="outlined"
          className={input}
        />

        <TextField
          disabled
          fullWidth
          variant="outlined"
          label="Email"
          name="email"
          value={appointmentRequest.email}
          className={input}
        />

        <TextField
          disabled
          fullWidth
          variant="outlined"
          label="Insurance ID"
          name="Insurance ID"
          value={appointmentRequest.insuranceId}
          className={input}
        />

        <TextField
          disabled
          fullWidth
          variant="outlined"
          label="Insurance Name"
          name="Insurance Name"
          value={appointmentRequest.InsuranceName}
          className={input}
        />

        <TextField
          fullWidth
          disabled
          multiline
          variant="outlined"
          rows="4"
          label="Reasons for Visit"
          name="reasonsForVisit"
          value={appointmentRequest.visitReason}
          className={input}
        />

        <TextField
          fullWidth
          multiline
          variant="outlined"
          rows="4"
          label="Admin notes"
          name="portalNotes"
          value={portalNotes}
          onChange={event => setPortalNotes(event.target.value)}
          className={input}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => save({
            ...appointmentRequest,
            portalNotes
          })}
          disabledDuringOnClick
          color="primary"
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
    float: 'right',
  },
  input: {
    margin: '0.5em 0',
  },
});

WebsiteAppointmentRequestViewModal.propTypes = {
  appointmentRequest: PropTypes.object,
  save: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(WebsiteAppointmentRequestViewModal);
